// src/pages/Activities.js
import React from 'react';
import { Link } from 'react-router-dom';

function Activities() {
  return (
    <div className="page">
      {/* Hero-style intro */}
      <div style={{ 
        background: 'linear-gradient(135deg, #f0fff4 0%, #c6f6d5 100%)',
        padding: '3rem 2rem',
        borderRadius: '20px',
        textAlign: 'center',
        marginBottom: '2rem',
        border: '1px solid rgba(56, 161, 105, 0.1)'
      }}>
        <h1 style={{ color: '#1b5e20', marginBottom: '1rem', fontSize: '2.5rem' }}>🏃‍♀️ DC Hawks Activities</h1>
        <p style={{ fontSize: '1.2rem', color: '#4A5568', maxWidth: '700px', margin: '0 auto 1rem auto' }}>
          Our activities aim at building community, improving fitness, and most
          importantly, making running fun! With most of our athletes training primarily 
          with their school track teams during the year, 
          this is what we do.
        </p>
        <p style={{ margin: 0 }}>
          <Link to="/racing" style={{ color: '#1b5e20', fontWeight: 'bold', fontSize: '1.1rem', textDecoration: 'none' }}>
            Check out our racing page →
          </Link>
        </p>
      </div>

      {/* Main Activities Cards */}
      <div className="highlights">
        <div className="highlight-card">
          <h3>🏃‍♀️ Saturday Parkruns</h3>
          <p><strong>Every Saturday 9:00 AM</strong> at Fletcher's Cove. Free, weekly, timed 5K for all ages and abilities!</p>
        </div>
        
        <div className="highlight-card">
          <h3>💪 Training Guidance</h3>
          <p>Age-appropriate advice and guidance to help young runners develop safely.</p>
        </div>
        
        <div className="highlight-card">
          <h3>🏃‍♂️ Practice Sessions</h3>
          <p>Occasional weekday practices mostly on non-school days.</p>
        </div>

        <div className="highlight-card">
          <h3>👥 Community Building</h3>
          <p>WhatsApp group connections, carpooling coordination, and mentorship between older and newer runners.</p>
        </div>
      </div>

      <div className="content-section">
        <h2>Saturday Parkruns at Fletcher's Cove</h2>
        <p>
          <strong>Every Saturday at 9:00 AM</strong> - This is the heart of DC Hawks! 
          Parkrun is a free, weekly, timed 5K run that's open to everyone aged 4 to 104.
        </p>

        <h3>What Makes Parkrun Special?</h3>
        <ul>
          <li><strong>Free</strong> - No cost to participate, ever</li>
          <li><strong>Inclusive</strong> - Walkers, joggers, and runners all welcome</li>
          <li><strong>Timed</strong> - Get your official time and track your progress</li>
          <li><strong>Family-friendly</strong> - Parents can run with or cheer for their kids</li>
          <li><strong>Community</strong> - Meet other local running families</li>
          <li><strong>Regular</strong> - Same time, same place, every week</li>
        </ul>

        <h3>What to Expect</h3>
        <ul>
          <li><strong>8:30 AM</strong> - Arrive for warmup</li>
          <li><strong>8:45 AM</strong> - Brief welcome and safety talk</li>
          <li><strong>9:00 AM</strong> - 5K run starts</li>
          <li><strong>9:30-45 AM</strong> - Most participants finish</li>
        </ul>

        <h3>Getting Started with Parkrun</h3>
        <ol>
          <li>Register once at <a href="https://www.parkrun.us/register/" target="_blank" rel="noopener noreferrer">parkrun.us/register</a></li>
          <li>Print your barcode (or save to your phone)</li>
          <li>Show up Saturday morning at Fletcher's Cove</li>
          <li>Run, walk, or jog the 5K course</li>
          <li>Get your barcode scanned at the finish</li>
          <li>Receive your official time by email</li>
        </ol>

        <div style={{ 
          background: '#f0f9ff', 
          padding: '1rem', 
          borderRadius: '8px', 
          margin: '1rem 0',
          border: '1px solid #0284c7'
        }}>
          <h4>📍 Location: Fletcher's Cove</h4>
          <p>
            <strong>Address:</strong> 4940 Canal Road NW, Washington, DC 20007<br/>
            <strong>Parking:</strong> Free parking available<br/>
            <strong>Course:</strong> Flat, paved path along the C&O Canal - perfect for beginners!
          </p>
          <p>
            <a 
              href="https://www.parkrun.us/fletcherscove/" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: '#0284c7', fontWeight: 'bold' }}
            >
              Visit Fletcher's Cove Parkrun Website →
            </a>
          </p>
        </div>
      </div>

    </div>
  );
}

export default Activities;